<template lang="pug">
div(:class="{ 'relative': $storyblok.isEditing }")
    WistiaThumb(
        v-if="data.mode === 'POPUP' && data.type == 'WISTIA'"
        :video="videoData"
    )
    VideoThumb(
        v-else-if="data.mode === 'POPUP' && data.type === 'YOUTUBE'"
        :video="videoData"
        :hiRes="true"
        @click.native="showLightbox = true"
    )
    Video(v-else :video="videoData")

    //- For YouTube, we have to make our own lightbox :(
    VideoLightbox(:video="videoData" v-if="showLightbox" @close="showLightbox = false")

    //- Shade for storyblok editor to prevent clicks
    div(
        v-if="$storyblok.isEditing"
        class="absolute inset-0 z-50"
    )
</template>

<script>
/* displays a normal 16:9 style player */
import Video from '@/components/video'
import VideoThumb from '@/components/video/thumb'
import WistiaThumb from '@/integrations/wistia/thumb'
const VideoLightbox = () =>
    import(/* webpackChunkName: "youtube-lightbox" */ '@/components/video/lightbox')

export default {
    name: 'VideoWidget',
    components: {
        Video,
        VideoThumb,
        WistiaThumb,
        VideoLightbox,
    },
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    data() {
        return {
            showLightbox: false,
        }
    },
    computed: {
        videoData() {
            const data = {
                id: '',
                type: this.data.type,
            }
            // set a single video ID for backwards compatibility
            if (this.data.id) data.id = this.data.id
            // set the mobile and/or desktop video IDs
            if (this.data.mobileId) data.id = this.data.mobileId
            if (this.data.desktopId && this.$device.isDesktop) data.id = this.data.desktopId
            return data
        },
    },
}
</script>
